import { render, staticRenderFns } from "./TempBienBanHCHT.vue?vue&type=template&id=16c110ca&scoped=true"
import script from "./TempBienBanHCHT.vue?vue&type=script&lang=js"
export * from "./TempBienBanHCHT.vue?vue&type=script&lang=js"
import style0 from "./TempBienBanHCHT.vue?vue&type=style&index=0&id=16c110ca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c110ca",
  null
  
)

export default component.exports